import clsx from 'clsx'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type Ref } from 'react'
import styles from './PostVideo.module.css'

export interface PostVideoProps extends HTMLMotionProps<'video'> {
	ref?: Ref<HTMLVideoElement>
}

export default function PostVideo({ ref, className, ...props }: PostVideoProps) {
	return (
		<motion.video
			ref={ref}
			controls
			muted
			height="364px"
			{...props}
			className={clsx(styles.video, className)}
		/>
	)
}
